import { render, staticRenderFns } from "./PUDetailsDowntimes.vue?vue&type=template&id=6db15982&scoped=true"
import script from "./PUDetailsDowntimes.vue?vue&type=script&lang=js"
export * from "./PUDetailsDowntimes.vue?vue&type=script&lang=js"
import style0 from "./PUDetailsDowntimes.vue?vue&type=style&index=0&id=6db15982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db15982",
  null
  
)

export default component.exports